'use strict';

module.exports = locate;

function locate(value, fromIndex) {
  var asterisk = value.indexOf('*', fromIndex);
  var underscore = value.indexOf('_', fromIndex);

  if (underscore === -1) {
    return asterisk;
  }

  if (asterisk === -1) {
    return underscore;
  }

  return underscore < asterisk ? underscore : asterisk;
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-parse/lib/locate/emphasis.js
// module id = 912
// module chunks = 95715928098905 168707334958949